import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { GenehmigungFileDialogComponent } from '@app/shared/components/dialog/genehmigung-file-dialog/genehmigung-file-dialog.component';
import { DataService } from '@app/shared/services/data/data.service';
import { PeziService } from '@app/shared/services/pezi.service';
import { DialogService } from '@app/shared/services/ui/dialog/dialog.service';
import { MessageService } from '@app/shared/services/ui/message/message.service';
import { ReactiveDialogService } from '@app/shared/services/ui/reactive-dialog.service';
import { GenehmigungDetail, GenehmigungFile, PolizzeResult } from '@o30/entities';
import { take } from 'rxjs/operators';

@Component({
  selector:    'app-genehmigung-detail',
  templateUrl: './genehmigung-detail.component.html',
  styleUrls:   ['./genehmigung-detail.component.scss'],
  standalone:  true,
  imports:     [
    NgIf,
    MatProgressSpinner,
    NgFor,
    MatIcon,
    NgClass,
    MatButton,
    MatTooltip
  ]
})

export class GenehmigungDetailComponent implements OnInit {
  protected messageService = inject(MessageService);
  protected reactiveDialogService = inject(ReactiveDialogService);
  protected dataService = inject(DataService);
  protected dialogService = inject(DialogService);

  private peziService = inject(PeziService);
  private destroyRef = inject(DestroyRef);

  @Input()
  polizzeResult: PolizzeResult;

  genehmigungDetail: GenehmigungDetail;
  loading = false;

  ngOnInit(): void {
    this.initGenehmigungDetail();
  }

  public getPreText(index: number): string {
    return index === 0 ? 'Zusätzliche Dokumente' : '';
  }

  public getStatusIconClass(dokument: GenehmigungFile): string {
    return dokument.missing ? 'red-icon' : 'green-icon';
  }

  public getStatusIcon(dokument: GenehmigungFile): string {
    return dokument.missing ? 'cancel' : 'check_circle';
  }

  public showGenehmigungFileDialog(dokument: GenehmigungFile): void {
    this.reactiveDialogService.open(GenehmigungFileDialogComponent,
        {
          data:     {
            title:             dokument.name,
            titleCloseEnabled: true
          },
          maxWidth: '500px'
        },
        {}, {
          polizzeId:       this.polizzeResult.id,
          personId:        this.polizzeResult.personId,
          genehmigungFile: dokument
        })
      .afterClosed()
      .subscribe(() => {
        this.initGenehmigungDetail();
      });
  }

  public navigateToPeziGenehmigung(): void {
    this.peziService.openPeziWithLogin(`/genehmigung/${this.genehmigungDetail.genehmTyp}/${this.genehmigungDetail.genehmId}`, this.destroyRef);
  }

  private initGenehmigungDetail(): void {
    this.loading = true;
    this.dataService.getGenehmigung(this.polizzeResult.id)
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(payload => {
        if (this.messageService.handlePayloadReturnSuccess(payload)) {
          this.genehmigungDetail = payload.data;
        }
        this.loading = false;
      });
  }
}
